import React from 'react';
// import AdminDropdown from '../../../adminDropdown';
//import { osloVerksteder } from '../../../../helpers/verksted-liste';
//import AdminVerkstedCard from '../../../adminVerkstedCard';
import useRetrieveKjedeVerksteder from '../../../../hooks/verksteder';
import Loader from '../../../loader';
import EgenAdminDropdown from '../../../egenAdminDropdown';

function AdminFinland(){

    const {verksteder, isLoading, isError } = useRetrieveKjedeVerksteder();

    // console.log(verksteder);

    const getVerkstedTitle = (verksted) => {
        const country = verksted.attributes.address.country;
        const region = verksted.attributes.address.region;
    
        // Lag en unik nøkkel basert på country og region
        const key = `${country}_${region}`;
    
        // Returner den unike nøkkelen
        return key;
    };

// Filtrer ut verksteder som ikke er i Norge
    const finskeVerksteder = verksteder.filter(verksted => {
        const address = verksted.attributes.address;
        return address && address.country === 'Finland';
        //verksted.attributes.address.country === 'Finland'
    });

// Grupper verksteder etter region
    const verkstederByLocation = finskeVerksteder.reduce((acc, verksted) => {
        const locationKey = getVerkstedTitle(verksted);
    
        if (!acc[locationKey]) {
            acc[locationKey] = [];
        }
    
        acc[locationKey].push(verksted);
        return acc;
    }, {});

    if(isLoading) {
        return(<div><Loader /></div>)
    }

    if(isError) {
        <p>Oida, noe gikk galt! Vennligst last inn siden på nytt</p>
    }

// Få en sortert rekkefølge av nøklene (regionene)
    const sortedRegions = Object.keys(verkstederByLocation).sort();

// Opprett dropdowns for hver region i sortert rekkefølge
    return (
        <div>
            {sortedRegions.map((regionKey, index) => {
                const [country, region] = regionKey.split('_');
                console.log(country);
                return (
                    <div key={index}>
                        <EgenAdminDropdown
                            title={region}
                            verksteder={verkstederByLocation[regionKey]}
                        />
                    </div>
                );
            })}
        </div>
    );

    
}

export default AdminFinland;